import type { AxiosRequestConfig } from 'axios';
import type {
  MemoryEventsParams,
  MemorySummary,
  MemorySummaryHistory,
  MemorySummaryRefreshResult,
  PaginatedMemoryEvents,
} from './memoryType';
import { get, post } from '../request';

/**
 * 获取当前用户的 AI 记忆摘要
 * 返回 MemorySummary 或 null（尚无摘要时）
 */
export async function getMemorySummary(): Promise<MemorySummary | null> {
  const result = await get<MemorySummary | { summary: null; message: string }>('/api/v1/memory/summary/');
  const data = result.data;
  // 后端在无摘要时返回 { summary: null, message: "No summary yet" }
  if (data && typeof data === 'object' && 'summary' in data && data.summary !== null) {
    return data as MemorySummary;
  }
  return null;
}

/**
 * 获取记忆事件列表（分页 + 筛选 + 搜索）
 */
export async function getMemoryEvents(
  params: MemoryEventsParams = {},
  config?: AxiosRequestConfig,
): Promise<PaginatedMemoryEvents> {
  const result = await get<PaginatedMemoryEvents>('/api/v1/memory/events/', params, config);
  return result.data;
}

export async function getMemorySummaryHistory(): Promise<MemorySummaryHistory> {
  const result = await get<MemorySummaryHistory>('/api/v1/memory/summary/', { include_legacy: true });
  return result.data;
}

export async function refreshMemorySummary(): Promise<MemorySummaryRefreshResult> {
  const result = await post<MemorySummaryRefreshResult>(
    '/api/v1/memory/summary/refresh/',
  );
  return result.data;
}
